import { Fragment, FunctionalComponent, h } from "preact";
import { DocumentIcon } from "../../../../icons/Document";

import { FullFlameIcon } from "../../../../icons/FullFlame";
import { PhoneIcon } from "../../../../icons/Phone";
import { UsersIcon } from "../../../../icons/Users";
import { ActivityItemStyled, Label, Date, RightContent, CenterContent, LeftContent, MetricAmount, ItemTypeName, Location } from "./activity-item.style";
import { ActivityItemI, ActivityItemType } from "./activity-item.types";

export const ActivityItem: FunctionalComponent<{ activityItem: ActivityItemI }> = ({
  activityItem
}) => {
  return (
    <ActivityItemStyled>
      <LeftContent>
        {(activityItem.itemTypeCode === ActivityItemType.Purchase && (activityItem.client === 'ios' || activityItem.client === 'android')) && (
          <PhoneIcon></PhoneIcon>
        )}

        {(activityItem.itemTypeCode === ActivityItemType.AdjustEarn) && (
          <UsersIcon></UsersIcon>
        )}

        {(activityItem.itemTypeCode === ActivityItemType.Purchase && (activityItem.client !== 'ios' && activityItem.client !== 'android')) && (
          <DocumentIcon></DocumentIcon>
        )}

        {(activityItem.itemTypeCode === ActivityItemType.Offer || activityItem.itemTypeCode === ActivityItemType.Reward) && (
          <FullFlameIcon></FullFlameIcon>
        )}
      </LeftContent>

      <CenterContent>
        <Label>{activityItem.label}</Label>
        <Date>{activityItem.activityDate}</Date>
      </CenterContent>

      <RightContent>
        <MetricAmount ItWasRedeemed={activityItem.metricAmount < 0}>{activityItem.metricAmount > 0 ? '+' : ''}{activityItem.metricAmount} pts</MetricAmount>
        <ItemTypeName>{activityItem.itemTypeName}</ItemTypeName>
      </RightContent>
    </ActivityItemStyled>
  )
}